import { styled } from '@creditas-ui/system'

export const Container = styled.div`
  cursor: text;
  margin-bottom: 24px;
`
